import script from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=40f30e9c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_version_3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f30e9c"]])

export default __exports__